import { useEffect, useRef } from "react";
import { Check } from "lucide-react";

export const DayStrip = ({ weeks, days, done, current, onSelect }) => {
  const ref = useRef(null);
  useEffect(() => {
    ref.current?.querySelector(`[data-day="${current}"]`)?.scrollIntoView({ behavior: "smooth", inline: "center", block: "nearest" });
  }, [current]);
  return (
    <div ref={ref} data-testid="day-strip" className="flex gap-5 overflow-x-auto pb-3 -mx-5 px-5 snap-x [scrollbar-width:none]">
      {weeks.map((w) => (
        <div key={w.n} className="shrink-0 snap-start">
          <p className="text-xs font-semibold text-[#7a6c5e] mb-2 whitespace-nowrap">Semana {w.n} · {w.title}</p>
          <div className="flex gap-1.5">
            {days.filter((d) => d.week === w.n).map((d) => {
              const isDone = done.has(d.day);
              const isCur = d.day === current;
              return (
                <button key={d.day} data-day={d.day} data-testid={`day-chip-${d.day}`} onClick={() => onSelect(d.day)}
                  className={`w-11 h-11 rounded-full text-sm font-semibold grid place-items-center transition-transform hover:-translate-y-0.5 ${isCur ? "ring-2 ring-offset-2 ring-[var(--accent)] ring-offset-[var(--cream)] scale-110" : ""} ${isDone ? "bg-[var(--sage-deep)] text-white" : "bg-white border-2 border-[#e3d6c4]"}`}>
                  {isDone ? <Check size={16} /> : d.day}
                </button>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
};
